<template>
  <select-create
    :model="model"
    :api="api"
    createApi="Companies/Create"
    :createRequest="createRequest"
    :createModel="formModel"
    :fields="{id: 'id', title: 'name'}"
    :templateFilter="templateFilter"
    v-bind="$attrs"
    v-on="$listeners"
    @validate="handlerValidate"
  >
    <template v-slot:form="{ change, data }">
      <create-form ref="form" :model="formModel" :data="data" @change="change"></create-form>
    </template>
  </select-create>
</template>

<script>
import { api } from '@/services/api'
export default {
  name: 'SelectCompany',
  components: {
    'select-create': () => import(/* webpackChunkName: 'Shared' */ '@/components/Form/UI/Selects/SelectCreate/Index'),
    'create-form': () => import(/* webpackChunkName: 'Shared' */ './Form.vue')
  },
  props: {
    model: { required: true },
    api: { type: String, default: 'Companies/GetAllDynamic' },
    fields: { id: 'id', title: 'name' }
  },
  computed: {
    formModel () {
      let model = {
        ...this.modelCompany(),
        ...this.modelCompanyDetails(),
        ...this.modelContact()
      }
      return () => model
    }
  },
  methods: {
    templateFilter (data) {
      return `name.StartsWith("${data.search}")`
    },
    modelCompany () {
      return {
        name: ''
      }
    },
    modelCompanyDetails () {
      return {
        companyID: null,
        companyTypeID: null,
        country: '',
        city: '',
        street: '',
        zipCode: '',
        state: '',
        addressTypeDivisionID: null,
        scoreID: null
      }
    },
    modelContact () {
      return {
        companyID: null,
        contactName: '',
        email: '',
        phone: '',
        divisionID: ''
      }
    },
    async createRequest (formData) {
      const requestCompany = await this.createCompany(formData)
      let companyID = requestCompany.id

      const requestCompanyDetail = await this.createCompanyDetail(companyID, formData)
      let companyDetailID = requestCompanyDetail.id

      const requestContact = await this.createContact(companyID, formData)
      let contactID = requestContact.id

      return {
        id: companyID,
        companyDetailID,
        contactID,

        company: requestCompany,
        companyDetail: requestCompanyDetail,
        companyContact: requestContact
      }
    },
    createCompany (formData) {
      let data = this.copyObjectProps(this.modelCompany(), formData)
      return api
        .post(`Companies/Create`, data)
        .then((response) => {
          return response.data
        })
    },
    createCompanyDetail (companyID, formData) {
      let data = this.copyObjectProps(this.modelCompanyDetails(), { ...formData, companyID })
      return api
        .post(`CompanyDetails/Create`, data)
        .then((response) => {
          return response.data
        })
    },
    createContact (companyID, formData) {
      let data = this.copyObjectProps(this.modelContact(), { ...formData, companyID })
      let contactName = data['contactName']
      delete data['contactName']
      data['name'] = contactName
      return api
        .post(`Contacts/Create`, data)
        .then((response) => {
          return response.data
        })
    },
    handlerValidate (callback) {
      this.$refs.form.validate()
        .then(() => {
          callback()
        })
        .catch(() => {
          callback(new Error('invalid company form'))
        })
    }
  }
}
</script>
